export default __webpack_public_path__ + "static/media/eg.98d46460.svg";